<lib-base-layout *ngIf="coreService.userLoggedIn | async;else hideBaseLayout">
  <router-outlet></router-outlet>
</lib-base-layout>

<ng-template #hideBaseLayout>
  <router-outlet></router-outlet>
</ng-template>

<p-toast key="{{ currentToastKey }}"></p-toast>
